/**
   * Custom version of z__jsRecommendedProducts.js by JadePuma
   * Last edited 10/22/25
 
 * - Fixes stale Search & Discovery recommendations caused by CDN/browser caching.
 * - Forces fresh data when viewing in theme editor or preview (adds cache-buster param).
 * - Ensures the request explicitly uses intent=related for proper "Related products" results.
 * - Filters out all auto-generated recommendations when pinned products exist,
 *   showing only the pinned items defined in the Search & Discovery app.
 *

  * Shopify caches the HTML returned by /recommendations/products for performance.
  * This script bypasses that cache for editors (using a timestamp param) so updates appear instantly.
  * It also prevents fallback products (e.g., Route, unrelated items) from showing
  * when you’ve pinned specific recommendations in Search & Discovery.
 * 
 */

/******/
(() => { // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme = window.PXUTheme || {};
  window.PXUTheme.jsRecommendedProducts = {
    init: function($section) {
      // Merge section settings into this instance
      window.PXUTheme.jsRecommendedProducts = $.extend(this, window.PXUTheme.getSectionData($section));

      const $wrap = $section.find('.product-recommendations');
      if (!$wrap.length) return;

      // If merchant forces a tagged collection, just reuse the server markup
      if (this.show_custom_collection) {
        this.showCustomCollection($section);
        return;
      }

      // Build the endpoint URL
      const productID = $wrap.data('product-id');
      const limit     = $wrap.data('limit');
      const sectionID = $wrap.data('section-id');
      const shopURL   = $wrap.data('base-url'); // routes.product_recommendations_url

      // Detect editor/preview to avoid stale CDN/browser cache *only for you*, not customers
      const inDesignMode =
        (window.Shopify && Shopify.designMode) ||
        document.documentElement.hasAttribute('data-design-mode');

      const requestUrl =
        `${shopURL}?section_id=${encodeURIComponent(sectionID)}&limit=${encodeURIComponent(limit)}&product_id=${encodeURIComponent(productID)}&intent=related${inDesignMode ? `&_=${Date.now()}` : ''}`;

      $.ajax({
        type: 'GET',
        url: requestUrl,
        cache: !inDesignMode,                   // ensure fresh in editor
        headers: { 'Accept': 'text/html' },
        success: function (html) {
          // If Shopify returned 0 items, hide the whole section wrapper
          var productsSize = $(html).find('script[data-products-size]').attr('data-products-size');
          if (productsSize === "0" || parseInt(productsSize, 10) === 0) {
            $wrap.closest('div.shopify-section').hide();
            return;
          }

          // Insert the returned section’s inner markup
          var inner = $(html).find('.product-recommendations').html();
          if (!inner) {
            $wrap.closest('div.shopify-section').hide();
            return;
          }
          $wrap.html(inner);

          // --- Keep only pinned items if any exist ---
          // Shopify adds `pr_prod_strat=pinned` into product links when item is pinned in S&D
          var $allTiles = $wrap.find('[data-load-more--grid-item], .product__grid-item, .product__thumbnail, .thumbnail');
          var $pinnedTiles = $wrap.find('a[href*="pr_prod_strat=pinned"]')
                                  .closest('[data-load-more--grid-item], .product__grid-item, .product__thumbnail, .thumbnail');

          if ($pinnedTiles.length) {
            $allTiles.not($pinnedTiles).remove();
          }

          // Re-init theme behaviors that expect newly injected DOM
          if (window.PXUTheme.jsProduct && typeof window.PXUTheme.jsProduct.relatedProducts === 'function') {
            window.PXUTheme.jsProduct.relatedProducts();
          }
          if (Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
            Shopify.PaymentButton.init();
          }
          if (window.PXUTheme.currencyConverter && typeof window.PXUTheme.currencyConverter.convertCurrencies === 'function') {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
        }
      });
    },

    setupRecommendedVideoPlayer: function($section) {
      const videosInRecommendedProducts = $section.find('[data-product-recommendations-container] [data-html5-video] video, [data-product-recommendations-container] [data-youtube-video]').get();
      if (videosInRecommendedProducts.length > 0) {
        videosInRecommendedProductsPlayer = Plyr.setup(videosInRecommendedProducts, {
          controls: videoControls,
          fullscreen: { enabled: true, fallback: true, iosNative: true },
          storage: { enabled: false }
        });
        if (videoPlayers !== null) {
          var combinedArray = videoPlayers.concat(videosInRecommendedProductsPlayer);
          videoPlayers = combinedArray;
        } else {
          videoPlayers = videosInRecommendedProductsPlayer;
        }
      }
      window.PXUTheme.jsVideo.setupListeners();
    },

    showCustomCollection: function($section) {
      const html = $section.find('.product-recommendations').html();
      const $container = $('.product-recommendations');
      $container.html(html);
      if (window.PXUTheme.jsProduct && typeof window.PXUTheme.jsProduct.relatedProducts === 'function') {
        window.PXUTheme.jsProduct.relatedProducts();
      }
    },

    unload: function($section) {}
  };
/******/ })();
